const REQUEST_GLOBAL = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_GLOBAL = (state, { body }) => {
  state.status = "success";
  state.Global = body;
};

const SET_GLOBAL_LOADED_AT = (state, loadedAt) => {
  state.globalLoadedAt = loadedAt;
};

const FAILURE_REQUEST_GLOBAL = state => {
  state.status = "failure";
};

const REQUEST_GLOBAL_ALL = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_GLOBAL_ALL = (state, { body }) => {
  state.status = "success";
  state.GlobalAll = body;
};

const SET_GLOBAL_ALL_LOADED_AT = (state, loadedAt) => {
  state.globalAllLoadedAt = loadedAt;
};

const UPSERT_GLOBAL_ALL = (state, globalVar) => {
  if (!globalVar || !globalVar._id) return;
  const index = state.GlobalAll.findIndex((item) => String(item._id) === String(globalVar._id));
  if (index >= 0) {
    state.GlobalAll.splice(index, 1, globalVar);
  } else {
    state.GlobalAll.push(globalVar);
  }
};

const FAILURE_REQUEST_GLOBAL_ALL = state => {
  state.status = "failure";
};

const SET_SELECTED_PROJECT = (state, projectId) => {
  state.selectedProjectId = projectId || null;
};

const REQUEST_UPDATE_GLOBAL = state => {
  state.statusUpdate = "fetching";
};

const SUCCESS_REQUEST_UPDATE_GLOBAL = state => {
  state.statusUpdate = "success";
};

const FAILURE_REQUEST_UPDATE_GLOBAL = state => {
  state.statusUpdate = "failure";
};

const REQUEST_CREATE_GLOBAL = state => {
  state.status = "fetching";
};

const SUCCESS_REQUEST_CREATE_GLOBAL = state => {
  state.statusCreate = "success";
};

const FAILURE_REQUEST_CREATE_GLOBAL = state => {
  state.statusCreate = "failure";
};



export default {
  SET_ACCESSIBLE_PROJECTS(state, projects) {
    state.accessibleProjects = projects;
  },
  REQUEST_GLOBAL,
  SUCCESS_REQUEST_GLOBAL,
  SET_GLOBAL_LOADED_AT,
  FAILURE_REQUEST_GLOBAL,
  REQUEST_GLOBAL_ALL,
  SUCCESS_REQUEST_GLOBAL_ALL,
  SET_GLOBAL_ALL_LOADED_AT,
  UPSERT_GLOBAL_ALL,
  FAILURE_REQUEST_GLOBAL_ALL,
  SET_SELECTED_PROJECT,
  REQUEST_UPDATE_GLOBAL,
  SUCCESS_REQUEST_UPDATE_GLOBAL,
  FAILURE_REQUEST_UPDATE_GLOBAL,
  REQUEST_CREATE_GLOBAL,
  SUCCESS_REQUEST_CREATE_GLOBAL,
  FAILURE_REQUEST_CREATE_GLOBAL,
};
